import axios from 'axios';
import {fullURL} from '../../utils';

export function fetchInsight(key, filter, params = {}) {
    if (!('values' in Object.keys(filter))) {
        if (!('filters' in Object.keys(filter['values']))) {
            filter['values']['filters'] = [];
        }
        if (!('logic' in Object.keys(filter['values']))) {
            filter['values']['logic'] = 'and';
        }
    }
    const postData = {...filter, params};
    return axios.post(fullURL(`/segment/insight/${key}`), postData)
        .then(({data}) => data)
        .catch(console.log);
}

export function fetchInsightSalesRecords(params = {}) {
    const postData = {params};
    console.log("postData", postData)
    // return axios.post(fullURL(`/dashboards/test/all`), postData)
    return axios.post(fullURL(`/dashboards/report/sales/list`), postData)
        .then(({data}) => data)
        .catch(console.log);
}

export function fetchListReports(params = {}, start_date, end_date) {
    const postData = {params};
    postData["start_date"] = start_date
    postData["end_date"] = end_date
    console.log("postData", postData)
    return axios.post(fullURL(`/dashboards/report/list`), postData)
        .then(({data}) => data)
        .catch(console.log);
}

export function fetchTargetReports(target_id, target_year) {
      return axios.get(
            fullURL(
                `/dashboards/target/${target_id}?year=${target_year}`
              )
          ).then(({data}) => data)
        .catch(console.log);
    }

export function fetchAllTargetReports() {
      return axios.get(
            fullURL(
                `/dashboards/target/all/current`
              )
          ).then(({data}) => data)
        .catch(console.log);
    }


export function defaultValues(keys) {
    return keys.reduce((o, k) => ({...o, [k]: null}), {});
}

export function maybeMissingValueLabel(label) {
    return label === null || label === undefined || label === '' ? 'Missing' : label;
}


export function lowerCase(str) {
    return str.trim()
        .split(/[\s_]+/)
        .map(word => word.charAt(0)
            .toLowerCase() + word.substring(1))
        .join(' ');
}

export function titleCase(str) {
    return str.trim()
        .split(/[\s_]+/)
        .map(word => word.charAt(0)
            .toUpperCase() + word.substring(1))
        .join(' ');
}

export const CATEGORICAL_INSIGHT_HEIGHT = 300;
